import { Validators } from '@angular/forms';
import { MultipleContractTypeSelectorComponent } from '@ordersnproducts/modules/one-click-order/components/contract-invoice-select/contract-invoice-select.component';
import { PurchaseOrderComponent } from '@ordersnproducts/modules/one-click-order/components/purchase-order/purchase-order.component';
import { OneClickContractEffects } from '@ordersnproducts/modules/one-click-order/effects/one-click-contract.effects';
import { OneClickJobsiteSalesAreaFromOrderEffects } from '@ordersnproducts/modules/one-click-order/effects/one-click-jobsite-sales-area.effects-order';
import { OneClickSalesAreaErrorEffects } from '@ordersnproducts/modules/one-click-order/effects/one-click-sales-area-error.effects';
import { OneCLickAlternativeUnitsEffects } from '@ordersnproducts/modules/one-click-order/effects/one-click-units.effects';
import {
  OneClickNoResultHasInvoiceProvider,
  OneClickNoResultNoInvoiceProvider,
} from '@ordersnproducts/modules/one-click-order/providers/order/one-click-contract-type-result.provider';
import { OneClickContractProvider } from '@ordersnproducts/modules/one-click-order/providers/order/one-click-contract.provider';
import { OneClickDeliveryMethodProvider } from '@ordersnproducts/modules/one-click-order/providers/order/one-click-delivery-method.provider';
import { OneClickPurchaseOrderProvider } from '@ordersnproducts/modules/one-click-order/providers/order/one-click-purchase-order.provider';
import { OneClickStandardLotProvider } from '@ordersnproducts/modules/one-click-order/providers/order/one-click-standard-lot.provider';
import { OneClickSetPurchaseOrder } from '@ordersnproducts/modules/one-click-order/services/commands/one-click-update-purchase-order.command';
import { OneClickSetQuantityOrder } from '@ordersnproducts/modules/one-click-order/services/commands/one-click-update-quantity.command.service';
import { OneClickUpdateSalesArea } from '@ordersnproducts/modules/one-click-order/services/commands/one-click-update-sales-area.command';
import { OneClickSetUnitOrder } from '@ordersnproducts/modules/one-click-order/services/commands/one-click-update-unit-command.service';
import { OneClickUnitsLoaderService } from '@ordersnproducts/modules/one-click-order/services/loaders/one-click-units.loader.service';
import { OneClickBuilderField } from '@ordersnproducts/modules/one-click-order/util/constants/builder-fields';
import { OneClickPurchaseOrderValidator } from '@ordersnproducts/modules/one-click-order/validators/one-click-purchase-order.validator';
import { MAX_LENGTH_PO } from '@ordersnproducts/modules/order-builder/modules/location/constants/purchase-order.constants';
import { ContractBalanceEffects } from '@ordersnproducts/modules/order-builder/modules/specification/effects/specification-form-effects/contract-balance.effects';
import { DecimalProvider } from '@ordersnproducts/modules/order-builder/modules/specification/providers/decimal.provider';
import { FormInputNumberComponent } from '@ordersnproducts/modules/shared/modules/configurable-form/components/form-input-number/form-input-number.component';
import { FormSelectComponent } from '@ordersnproducts/modules/shared/modules/configurable-form/components/form-select/form-select.component';
import { FieldSelectConfig } from '@ordersnproducts/modules/shared/modules/configurable-form/components/form-select/models/field-select-config.interface';
import { FormSeparatorComponent } from '@ordersnproducts/modules/shared/modules/configurable-form/components/form-separator/form-separator.component';
import { FieldInputNumberConfig } from '@ordersnproducts/modules/shared/modules/configurable-form/models/field-configs/field-input-number-config.interface';
import { FormGenericItemComponent } from '../../../../../shared/modules/configurable-form/components/form-generic-item/form-generic-item.component';
import { FieldConfig } from '../../../../../shared/modules/configurable-form/models/field-configs/field-config.interface';
import { FieldLabelConfig } from '../../../../../shared/modules/configurable-form/models/field-configs/field-label-config.interface';
import { OneClickLocationProvider } from '../../../../providers/order/one-click-location.provider';
import { OneClickLocationDisplayer } from '../../../../providers/order/one-click-multiple-jobsite-displayer.provider';
import {
  OneClickContractPaymentProvider,
  OneClickHasResultProvider,
  OneClickNoResultProvider,
} from '../../../../providers/order/one-click-payment.provider';
import { OneClickPlantsProvider } from '../../../../providers/order/one-click-plants.provider';
import { OneClickProductProvider } from '../../../../providers/order/one-click-product.provider';
import { OneClickPreviewField } from '../../../../util/constants/preview-fields';

export const preview: FieldConfig[] = [
  {
    type: FormGenericItemComponent,
    name: OneClickPreviewField.Jobsite,
    label: 'views.one_click.jobsite',
    hidden: OneClickLocationDisplayer.HideJobsite,
    text: OneClickLocationProvider.TextPreview,
    containerClassNames: ['col-12 mb-2 text-capitalize'],
    dataTIdLabel: 'cmx-createoneclickorder-lbltagjobsite',
    dataTIdValue: 'cmx-createoneclickorder-lblvaljobsite',
  } as FieldLabelConfig,
  {
    type: FormGenericItemComponent,
    name: OneClickPreviewField.PointOfDelivery,
    label: 'views.one_click.pod',
    hidden: OneClickLocationDisplayer.HidePointOfDelivery,
    text: OneClickLocationProvider.TextPreview,
    containerClassNames: ['col-12 mb-2 text-capitalize'],
    dataTIdLabel: 'cmx-createoneclickorder-lbltagpointofdelivery',
    dataTIdValue: 'cmx-createoneclickorder-lblvalpointofdelivery',
  } as FieldLabelConfig,
  {
    type: FormGenericItemComponent,
    name: OneClickPreviewField.DeliveryMethod,
    text: OneClickDeliveryMethodProvider.TextPreview,
    label: 'views.one_click.delivery_method',
    containerClassNames: ['col-md-2 text-capitalize'],
    dataTIdLabel: 'cmx-createoneclickorder-lbltagdeliverymethod',
    dataTIdValue: 'cmx-createoneclickorder-lblvaldeliverymethod',
  } as FieldLabelConfig,
  {
    type: FormGenericItemComponent,
    name: OneClickPreviewField.Product,
    text: OneClickProductProvider,
    label: 'views.one_click.product',
    containerClassNames: ['col-md-6 text-capitalize'],
    dataTIdLabel: 'cmx-createoneclickorder-lbltagproduct',
    dataTIdValue: 'cmx-createoneclickorder-lblvalproduct',
  } as FieldLabelConfig,
  {
    type: FormGenericItemComponent,
    name: '',
    text: OneClickStandardLotProvider,
    label: 'views.specifications.quantity',
    containerClassNames: ['col-md-4 text-capitalize'],
    dataTIdLabel: 'cmx-createoneclickorder-lbltagquantity',
    dataTIdValue: 'cmx-createoneclickorder-lblvalquantity',
    hidden: OneClickNoResultProvider,
  } as FieldLabelConfig,
  {
    type: FormGenericItemComponent,
    name: OneClickPreviewField.Payment,
    text: OneClickContractPaymentProvider,
    label: 'views.one_click.payment_method',
    containerClassNames: ['col-md-2 text-capitalize'],
    dataTIdLabel: 'cmx-createoneclickorder-lbltagpayment',
    dataTIdValue: 'cmx-createoneclickorder-lblvalpayment',
  } as FieldLabelConfig,
  {
    type: FormGenericItemComponent,
    name: OneClickPreviewField.Plant,
    text: OneClickPlantsProvider,
    label: 'views.one_click.plant',
    containerClassNames: ['col-md-6 text-capitalize'],
    dataTIdLabel: 'cmx-createoneclickorder-lbltagplant',
    dataTIdValue: 'cmx-createoneclickorder-lblvalplant',
  } as FieldLabelConfig,
  {
    type: FormSeparatorComponent,
    name: '',
    containerClassNames: ['col-md-12'],
    hidden: OneClickHasResultProvider,
  } as FieldConfig,
  {
    type: FormInputNumberComponent,
    label: 'views.specifications.quantity',
    containerClassNames: ['col-md-3 retail-control'],
    name: OneClickPreviewField.Quantity,
    min: 1,
    value: 1,
    step: 1,
    max: 99999,
    decimals: DecimalProvider,
    validation: [Validators.required, Validators.min(1), Validators.max(99999)],
    dynamicEffects: [OneClickSalesAreaErrorEffects],
    onChange: [OneClickSetQuantityOrder, OneClickUpdateSalesArea],
    hidden: OneClickHasResultProvider,
  } as FieldInputNumberConfig,
  {
    type: FormSelectComponent,
    label: 'views.specifications.unit',
    name: OneClickBuilderField.Unit,
    placeholder: '',
    containerClassNames: ['col-md-3 retail-control'],
    onChange: [OneClickSetUnitOrder],
    dynamicEffects: [OneCLickAlternativeUnitsEffects],
    optionsLoader: OneClickUnitsLoaderService,
    validation: [Validators.required],
    hidden: OneClickHasResultProvider,
  } as FieldSelectConfig,
  {
    type: PurchaseOrderComponent,
    name: OneClickPreviewField.PurchaseOrder,
    label: 'views.one_click.purchase_order',
    dynamicEffects: [OneClickJobsiteSalesAreaFromOrderEffects],
    onChange: [OneClickSetPurchaseOrder],
    hidden: OneClickHasResultProvider,
    placeholder: 'views.one_click.enter_purchase_order',
    containerClassNames: ['col-md-6 text-capitalize retail-control'],
    validation: [Validators.maxLength(MAX_LENGTH_PO)],
    asyncValidators: [OneClickPurchaseOrderValidator.validator],
  } as FieldConfig,
  {
    type: MultipleContractTypeSelectorComponent,
    name: OneClickPreviewField.Contract,
    hidden: OneClickHasResultProvider,
    dynamicEffects: [OneClickContractEffects, ContractBalanceEffects],
    label: '',
    containerClassNames: ['col-md-12 mt-3'],
  } as FieldConfig,
  {
    type: FormGenericItemComponent,
    name: OneClickPreviewField.Contract,
    hidden: OneClickNoResultHasInvoiceProvider,
    text: OneClickContractProvider,
    label: 'views.one_click.contract',
    containerClassNames: ['col-md-6'],
  } as FieldLabelConfig,
  {
    type: FormGenericItemComponent,
    name: OneClickPreviewField.Contract,
    hidden: OneClickNoResultNoInvoiceProvider,
    text: OneClickContractProvider,
    label: 'views.one_click.invoice',
    containerClassNames: ['col-md-6'],
  } as FieldLabelConfig,
  {
    type: FormGenericItemComponent,
    name: OneClickPreviewField.PurchaseOrder,
    hidden: OneClickNoResultProvider,
    text: OneClickPurchaseOrderProvider,
    label: 'views.one_click.purchase_order',
    containerClassNames: ['col-md-6'],
  } as FieldLabelConfig,
];
